import { useTranslation } from 'react-i18next';
import { FooterV2 } from '@cx-web/components/composites';
import Logo from '@cx-web/components/primitives/Logo';

import FooterOC from '~/apps/product-plus/components/FooterOC';
import FooterWS from '~/apps/product-plus/components/FooterWS';
import { getSocialLinks } from '~/constants/social-lnks';
import { useLayoutStore } from '~/providers/layout-store-provider';
import { useRepubContext } from '~/providers/repub-context';
import { useCmpProps } from '~/utils/cmp';

import styles from './styles/Footer.module.css';

export type FooterProps = {
  resourcesUrl: string;
};

export default function Footer({ resourcesUrl }: FooterProps) {
  const { repubIs } = useRepubContext();
  const footerData = useLayoutStore((s) => s.footerData);
  const isAdmiralCookieBannerEnabled = useLayoutStore((s) => s.isAdmiralCookieBannerEnabled);
  const cmpProps = useCmpProps();
  const { t } = useTranslation(['label']);

  const renderProductPlusFooter = () => {
    if (repubIs.WS) {
      return <FooterWS resourcesUrl={resourcesUrl} />;
    }

    if (repubIs.OC) {
      return <FooterOC />;
    }

    if (repubIs.GZ) {
      return null;
    }

    return (
      <FooterV2
        cmpProps={cmpProps}
        footerData={footerData}
        isAdmiralCookieBannerEnabled={isAdmiralCookieBannerEnabled}
        legalAge={t('CX_LEGAL_AGE')}
        legalText={t('CX_FOOTER_LEGAL')}
        logo={<Logo resourcesUrl={resourcesUrl} />}
        socialLinks={getSocialLinks(t)} />);


  };

  return (
    <footer className={styles.footer} id="mainAppFooter">
      {renderProductPlusFooter()}
    </footer>);

}